// Abre a conversa do WhatsApp com a mensagem pronta (boleto/nota) sem ficar
// empilhando abas.
//
// O link que o servidor monta é https://wa.me/<fone>?text=..., que no
// computador cai na página "Conversar com ... no WhatsApp" (api.whatsapp.com)
// — uma aba nova a cada envio E ainda abre o aplicativo. Aqui o link é
// convertido conforme a escolha guardada NESTE computador (localStorage, pois
// ter o app instalado é coisa da máquina, não do usuário):
//   'app' → whatsapp://send?... abre direto o WhatsApp instalado, sem aba;
//   'web' → https://web.whatsapp.com/send?... sempre na MESMA aba (janela
//           nomeada), reaproveitada a cada envio.
// No celular continua o wa.me (o próprio sistema abre o app).
//
// Uso (o preparar() tem que rodar ANTES de qualquer await, ainda dentro do
// clique — senão o navegador bloqueia a janela; ver impressaoVenda.js):
//   const alvo = prepararWhatsApp();
//   const { data } = await api.get(...);
//   if (data.whatsapp_url) alvo.abrir(data.whatsapp_url); else alvo.cancelar();

const CHAVE = 'emais_whatsapp_modo';
const NOME_ABA = 'emais_whatsapp_web';

export function ehCelular() {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
}

export function lerModoWhatsApp() {
  try { const v = localStorage.getItem(CHAVE); return v === 'app' || v === 'web' ? v : null; } catch { return null; }
}

export function salvarModoWhatsApp(modo) {
  try { if (modo) localStorage.setItem(CHAVE, modo); else localStorage.removeItem(CHAVE); } catch { /* sem storage: pergunta de novo */ }
}

// wa.me/<fone>?text=X  |  api.whatsapp.com/send?phone=<fone>&text=X  →  { fone, texto }
export function partesDoLink(url) {
  try {
    const u = new URL(url);
    let fone = u.searchParams.get('phone') || '';
    if (!fone && /(^|\.)wa\.me$/i.test(u.hostname)) fone = u.pathname.replace(/\D/g, '');
    return { fone: fone.replace(/\D/g, ''), texto: u.searchParams.get('text') || '' };
  } catch { return null; }
}

export function linkPara(modo, url) {
  const p = partesDoLink(url);
  if (!p) return url;
  const q = `phone=${p.fone}&text=${encodeURIComponent(p.texto)}`;
  if (modo === 'app') return `whatsapp://send?${q}`;
  if (modo === 'web') return `https://web.whatsapp.com/send?${q}`;
  return url;
}

function perguntarModo() {
  const app = window.confirm(
    'Este computador tem o aplicativo do WhatsApp instalado?\n\n' +
    'OK = abrir direto no aplicativo (não abre aba no navegador)\n' +
    'Cancelar = usar o WhatsApp Web, sempre na mesma aba\n\n' +
    'A escolha fica guardada neste computador. Para trocar: botão "💬 WhatsApp" dos títulos marcados → "Abrir em".');
  const modo = app ? 'app' : 'web';
  salvarModoWhatsApp(modo);
  return modo;
}

export function prepararWhatsApp() {
  if (ehCelular()) {
    const win = window.open('', '_blank');
    return { abrir: (url) => { if (win) win.location.href = url; else window.location.href = url; }, cancelar: () => win?.close() };
  }
  const modo = lerModoWhatsApp() || perguntarModo();
  if (modo === 'app') {
    // Protocolo externo: não abre aba nenhuma, só chama o aplicativo.
    return { abrir: (url) => { window.location.href = linkPara('app', url); }, cancelar: () => {} };
  }
  // Janela nomeada: se a aba do WhatsApp Web aberta antes pelo sistema ainda
  // existe, o navegador devolve ELA em vez de criar outra.
  const win = window.open('', NOME_ABA);
  let usada = false;
  return {
    abrir: (url) => {
      usada = true;
      const destino = linkPara('web', url);
      if (win) { win.location.href = destino; win.focus?.(); } else window.open(destino, NOME_ABA);
    },
    // Só fecha se a aba acabou de ser criada em branco (não derruba um
    // WhatsApp Web que já estava aberto e logado).
    cancelar: () => { try { if (!usada && win && win.location.href === 'about:blank') win.close(); } catch { /* aba já no whatsapp (outra origem): deixa */ } },
  };
}
